import i18n from 'helpers/i18n';
import messages from './messages';
import { useEffect } from 'react';
import useAsync from 'hooks/useAsync';
import { useMeasure } from 'context/measure';
import { Loader } from 'semantic-ui-react';
import {
  getCustomQuestions,
  GetCustomQuestionsRes
} from 'actions/envScales/observationFeedback';

import {
  Section,
  SectionHeader,
  SectionContent,
  SectionDetail
} from 'components/Measure/View/Styled';

function CustomQuestions() {
  const { assessment } = useMeasure();
  const { run, data: questions, isPending } = useAsync<GetCustomQuestionsRes>();

  useEffect(() => {
    run(getCustomQuestions(assessment.id));
  }, [run, assessment.id]);

  if (isPending) {
    return <Loader active inline="centered" />;
  }

  const hasQuestions = questions?.questions_with_answers?.length > 0;

  return (
    <Section className="mt-2">
      <SectionHeader>{i18n.ft(messages.title)}</SectionHeader>

      <SectionContent className="flex flex-col gap-4">
        {hasQuestions &&
          questions.questions_with_answers.map(question => (
            <SectionDetail key={question.question_id}>
              <dl>
                <dt className="font-bold">{question.question}</dt>
                <dd className="mt-2 whitespace-pre-wrap">
                  {question.question_type === 'free_text'
                    ? question.answer_notes
                    : question.options.find(
                        opt => opt.id === question.answer_id
                      )?.option}
                </dd>
              </dl>
            </SectionDetail>
          ))}
      </SectionContent>
    </Section>
  );
}

export default CustomQuestions;
